// UI exports
export { RenderCard } from './ui/RenderCard';
export {
  UnifiedRenderPanel,
  type UnifiedRenderPanelRef,
} from './ui/unified-panel';
export { RenderProgress, type RenderProgressMode } from './ui/RenderProgress';
export { RenderProgressBar } from './ui/RenderProgressBar';
export { GoalsEnhanceModal } from './ui/GoalsEnhanceModal';
export {
  AngleImageWithProgress,
  type AngleImageWithProgressProps,
} from './ui/AngleImageWithProgress';
export { AIGlowBorder } from './ui/ai-glow-border/AIGlowBorder';

// Model exports
export {
  useRenderStore,
  useFormData,
  useSelectedControlIds,
  useSelectedReferences,
  useSeed,
  useSelectedRenderId,
  useShowRenderDetails,
  useHasChanges,
  useIsValidForSubmit,
  useFormDataWithSeed,
  type RenderStore,
  type RenderFormData,
} from './model/render-form.store';

// Selector exports (only unique selectors not already exported from render-form.store above)
export {
  useRenderSettingsState,
  useRenderSettingsActions,
  useSectionChanges,
} from './model/render-form-store.selectors';

// Hook exports
export { useRenderPanelLogic } from './hooks/use-render-panel-logic';
export { useRenderSettings } from './hooks/use-render-settings';
export { useRenderForm } from './hooks/use-render-form';
export { useRenderSubmit } from './hooks/use-render-submit';
export { useSeedManagement } from './hooks/use-seed-management';
export {
  useRenderProgress,
  type UseRenderProgressOptions,
  type RenderProgressState,
} from './hooks/use-render-progress';
export {
  useLoadingContent,
  type UseLoadingContentOptions,
  type LoadingContentState,
} from './hooks/use-loading-content';
export {
  useAngleRendersData,
  type AngleRendersData,
  type UseAngleRendersDataOptions,
} from './hooks/use-angle-renders-data';

// API exports
export { stylesService } from './api/styles';
export { materialsService } from './api/materials';

export { useRenderOperations } from './hooks/use-render-operations';
export { useRenderPreflight } from './hooks/use-render-preflight';
